import { Flex } from "antd";
import { Fragment } from "react";
import { Link } from "react-router";
import RightArrowIcon from "../assets/icons/RightArrowIcon";
import { cn } from "../utils/global.utils";

export type TBreadcrumb = {
  title: string;
  path?: string;
};

type ClassNames = {
  link?: string;
  last?: string;
  icon?: string;
};

type Props = {
  breadcrumb: TBreadcrumb[];
  className?: string;
  classNames?: ClassNames;
};
export default function Breadcrumb({
  breadcrumb,
  className,
  classNames,
}: Props) {
  return (
    <Flex align="center" justify="center" gap={6} wrap className={className}>
      {breadcrumb.map((el, index) => {
        const isLast = index === breadcrumb.length - 1;

        return isLast ? (
          <span
            key={el.title}
            className={cn(
              "text-base font-normal text-theme-yellow-400",
              classNames?.last
            )}
          >
            {el.title}
          </span>
        ) : (
          <Fragment key={el.title}>
            <Link
              className={cn(
                "text-white text-base font-normal hover:text-white",
                classNames?.link
              )}
              to={el.path || "#"}
            >
              {el.title}
            </Link>
            <RightArrowIcon
              className={cn(
                "text-theme-slate-500 relative -top-[1px]",
                classNames?.icon
              )}
            />
          </Fragment>
        );
      })}
    </Flex>
  );
}
